import { isCuPhapMn } from "../utils/common"

export const groupToLoaiCuoc: any = isCuPhapMn() ? {
    "Dau2C": ["Dau2C"] as string[],
    "Duoi2C": ["Duoi2C"] as string[],
    "2CBao": ["Lo2C", "6Lo2C", "7Lo2C"] as string[],
    "3C": ["6Lo3C", "7Lo3C", "Lo3C", "XC", "XcDau", "XcDuoi"] as string[],
    "4C": ["Dau4C", "Duoi4C", "Lo4C"] as string[],
    "Da": ["DaT", "DaX", "Xi2", "Xi3", "Xi4"] as string[]
} : {
    "De": ["De"] as string[],
    "DeA": ["DeA",] as string[],
    "Lo": ["Lo"] as string[],
    "LoA": ["LoA"] as string[],
    "Nhat": ["Giai1", "Giai2", "Giai3"] as string[],
    "NhatA": ["Giai1A",] as string[],
    "Xien": ["DaT", "DaX", "Xi2", "Xi3", "Xi4"] as string[],
    "XienA": ["Xi2A", "Xi3A", "Xi4A"] as string[],
    "3c": ["3c", "3cA", "3c1", "3c1A"] as string[],
    "Giai2": ["Giai2", "Giai3"] as string[],
}
export const groupCuoc = isCuPhapMn() ? ["Dau2C", "Duoi2C", "2CBao", "3C", "4C", "Da"]
    : ["De", "DeA", "3c", "Lo", "LoA", "Xien", "XienA", "Nhat", "NhatA", "Giai2"]

export function GetLoaiCuocIdsFromGroups(selectedGroups: string[]): string[] {
    let result: string[] = []
    selectedGroups.forEach((group: string) => {
        const find: string[] = groupToLoaiCuoc[group] || []
        result = result.concat(find);
    })
    return result;
}